import { createAction } from '@reduxjs/toolkit'

export const testNlgServiceKey = 'api/nlg/testNlgService'
export const testNlgServiceRequested = createAction(`${testNlgServiceKey}/requested`)
export const testNlgServiceSuccess = createAction(`${testNlgServiceKey}/success`)
export const testNlgServiceFailed = createAction(`${testNlgServiceKey}/failed`)
